import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';

@Component({
  selector: 'vex-trophy-detail',
  templateUrl: './trophy-detail.component.html',
  styleUrls: ['./trophy-detail.component.scss']
})
export class TrophyDetailComponent implements OnInit {
  @Input() trophy;

  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, public guiService: GuiService,
      public translate: TranslateService) {
        this.trophy = data.trophy;
  }

  ngOnInit() {
    console.debug(this.trophy)
  }

  closeModal() {
    this.dialogRef.close();
  }

}
